export default function MuiFilledInput(theme) {
  return {
    root: {
      backgroundColor: theme.palette.background.default,
      "&:hover": {
        backgroundColor: theme.palette.background.default,
      },
      "&$focused": {
        backgroundColor: theme.palette.background.default,
      },
    },
  };
}
